// Internal KYC was replaced by an external compliance provider. The screens are gated rather
// than deleted so historical records stay readable and the flag can flip back if the provider
// ever needs an operator view inside Flippex.
export const INTERNAL_KYC_UI = false;
